import Events from 'f.core.event';
export default new Events();


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.gift.mobile/app/lib/eventBus.js